import React from 'react';
import { getCentreAcknowledgementCountry } from '@scentregroup/shared/helpers/get-centre-acknowledgement';
import { makeMailUrl } from '../../helpers';
import { conciergeTitle } from '../../helpers/concierge';
import { Stack } from '@hub/stack';
import { Box } from '@hub/box';
import { Text } from '@hub/text';
import { Link } from '@hub/link';
import { FacebookMediumIcon, InstagramMediumIcon } from '@hub/icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const CentreDetails = _ref => {
  let {
    centre,
    onFindACentre
  } = _ref;
  const country = getCentreAcknowledgementCountry(centre.slug);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      direction: "column",
      justify: "flex-end",
      "data-id": "universal-footer_centre-details_CentreDetails_Stack",
      children: [/*#__PURE__*/_jsxs(Stack, {
        direction: "row",
        gap: 'spacing-md',
        "data-id": "universal-footer_centre-details_CentreDetails_Stack_Stack_1",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "span",
          tone: "strong",
          "data-id": "universal-footer_centre-details_CentreDetails_Stack_Text",
          children: centre.title
        }), onFindACentre && /*#__PURE__*/_jsx(Box, {
          as: "button",
          sx: {
            textDecoration: 'underline'
          },
          onClick: onFindACentre,
          "data-id": "universal-footer_centre-details_CentreDetails_Box",
          children: "Change\xA0centre"
        })]
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          marginTop: 'spacing-sm'
        },
        "data-id": "universal-footer_centre-details_CentreDetails_Stack_Box_4",
        children: [!!country && /*#__PURE__*/_jsxs(_Fragment, {
          children: [country, " ", /*#__PURE__*/_jsx("br", {
            "data-id": "universal-footer_centre-details_CentreDetails_br"
          })]
        }), centre.physicalAddress, " ", /*#__PURE__*/_jsx("br", {
          "data-id": "universal-footer_centre-details_CentreDetails_Box_br_6"
        }), centre.suburb, " ", centre.state, " ", centre.postcode, " ", /*#__PURE__*/_jsx("br", {
          "data-id": "universal-footer_centre-details_CentreDetails_Box_br_7"
        }), /*#__PURE__*/_jsx(Link, {
          href: "tel:".concat(centre.telephoneNumber),
          "data-id": "universal-footer_centre-details_CentreDetails_Box_Link",
          children: centre.telephoneNumber
        })]
      }), /*#__PURE__*/_jsx(Link, {
        href: makeMailUrl(centre.emailAddress),
        sx: {
          marginBottom: 'spacing-sm'
        },
        "data-id": "universal-footer_centre-details_CentreDetails_Stack_Link_9",
        children: "Contact ".concat(centre.title, " ").concat(conciergeTitle(centre.country, centre.slug))
      })]
    }), /*#__PURE__*/_jsx(Stack, {
      direction: "row",
      justify: 'flex-start',
      marginTop: 'spacing-md',
      "data-test-id": "contact-links",
      "data-id": "universal-footer_centre-details_CentreDetails_Stack",
      children: centre.contactLinks.filter(_ref2 => {
        let {
          type
        } = _ref2;
        return type !== 'twitter';
      }).map(contact => contact.url && /*#__PURE__*/_jsxs(Link, {
        href: contact.url,
        "aria-label": "Go to Westfield ".concat(centre.title, "'s ").concat(contact.type),
        "data-id": "universal-footer_centre-details_CentreDetails_Link",
        children: [contact.type === 'facebook' && /*#__PURE__*/_jsx(FacebookMediumIcon, {
          sx: {
            marginRight: 'spacing-xl',
            color: 'quartz',
            height: 'size-icon-md',
            width: 'size-icon-md'
          },
          ariaLabel: "Go to Westfield ".concat(centre.title, "'s ").concat(contact.type),
          "data-id": "universal-footer_centre-details_CentreDetails_FacebookMediumIcon"
        }, contact.type), contact.type === 'instagram' && /*#__PURE__*/_jsx(InstagramMediumIcon, {
          sx: {
            color: 'quartz',
            height: 'size-icon-md',
            width: 'size-icon-md'
          },
          ariaLabel: "Go to Westfield ".concat(centre.title, "'s ").concat(contact.type),
          "data-id": "universal-footer_centre-details_CentreDetails_InstagramMediumIcon"
        }, contact.type)]
      }, contact.type))
    })]
  });
};